export default "__VITE_ASSET__DVsOA0U8__"